export var isDateRange = function isDateRange(date) {
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!date || typeof date !== 'object') return false;
  var maybe = date;
  return 'from' in maybe && 'to' in maybe && maybe.from instanceof Date && maybe.to instanceof Date;
};
export var isDateRangeFromSelectedLabel = function isDateRangeFromSelectedLabel(selectedDateLabel) {
  return Boolean(selectedDateLabel.from && selectedDateLabel.to);
};
export var setHours = function setHours(date) {
  var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var newDate = new Date(date);
  newDate.setHours(initial ? 0 : 23, initial ? 0 : 59, initial ? 0 : 59);
  return newDate;
};

// Función para construir el HOME_PATH dinámicamente basado en el rol del usuario
export var getHomePath = function getHomePath(slug, role) {
  if (!slug || !role) {
    return undefined;
  }

  // Determinar si es admin basado en el rol de la organización
  var isAdmin = role === 'admin';
  var safeSlug = encodeURIComponent(slug);
  if (isAdmin) {
    return "/org/".concat(safeSlug, "/ai/admin/chat/");
  } else {
    return "/org/".concat(safeSlug, "/ai/user/chat/");
  }
};